// TablePoint.jsx
import React, { useCallback, useMemo, useState } from "react";
import { headers, url } from "../../../utils/const";
import { EyeFill, PenFill, XCircle } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import { ReportPDF } from "../../../utils/print-pdf/report-pdf";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";
import imgLogo from "../../../assets/logo-vlb.png";

// ✅ Nunca rompe React: convierte cualquier cosa a texto
const safe = (v) => {
  if (v === null || v === undefined) return "";
  const t = typeof v;
  if (t === "string" || t === "number" || t === "boolean") return String(v);
  if (Array.isArray(v)) return v.map(safe).filter(Boolean).join(", ");
  if (t === "object") {
    if ("name" in v) return safe(v.name);
    if ("userName" in v) return safe(v.userName);
    if ("user" in v) return safe(v.user);
    if ("_id" in v) return safe(v._id);
    try {
      return JSON.stringify(v);
    } catch {
      return "";
    }
  }
  return "";
};

const getByPath = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
};

// ✅ convierte fila a texto para filtro “cualquier campo”
const rowToSearchText = (row) => {
  const seen = new Set();
  const walk = (x, depth) => {
    if (x === null || x === undefined) return "";
    const t = typeof x;
    if (t === "string" || t === "number" || t === "boolean") return String(x);
    if (Array.isArray(x)) return depth <= 0 ? "" : x.map((i) => walk(i, depth - 1)).join(" ");
    if (t === "object") {
      if (seen.has(x)) return "";
      seen.add(x);
      if (depth <= 0) return safe(x);
      return Object.values(x)
        .map((v) => walk(v, depth - 1))
        .join(" ");
    }
    return "";
  };
  return walk(row, 2).toLowerCase();
};

const n2 = (val) => {
  const num =val && val.length>0? val.reduce((a, c) => a + c.betted, 0): Number(val);
  if (Number.isNaN(num)) return "";
  return num.toLocaleString("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

function TablePoint(props) {
  const list = Array.isArray(props.list) ? props.list : [];
  const date = props.date;
  // ===================== MODAL REPORTE VENTA (YA EXISTÍA) =====================
  const [show, setShow] = useState(false);
  const [pointShow, setPointShow] = useState(null);

  const handleShow = (z) => {
    setPointShow(z);
    setShow(true);
  };
  const handleClose = () => setShow(false);

  // ===================== FILTRO + ORDEN =====================
  const [q, setQ] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortDir, setSortDir] = useState("asc");

  const columns = useMemo(
    () => [
      { key: "#", label: "Num", sortable: false },
      { key: "code", label: "Codigo", sortable: true },
      { key: "name", label: "Puntos", sortable: true },
      { key: "customer.name", label: "Socios", sortable: true },
      { key: "address.city", label: "Ciudad", sortable: true },
      { key: "_static.counterTicket", label: "Tickets", sortable: true },
      { key: "_static.amountBetted", label: "Apostado", sortable: true },
      { key: "_static.amountWinned", label: "Gandado", sortable: true },
      { key: "_static.amountPaid", label: "Pagado", sortable: true },
      { key: "_static.noPaid", label: "No_Pagado", sortable: true },
      { key: "_static.dep", label: "Recarga", sortable: true },
      { key: "_static.ret", label: "Retiros", sortable: true },
      { key: "_static.caja", label: "Total_en_Caja", sortable: true },
      { key: "_static.jackpotPaid", label: "Jackpot", sortable: true },
      { key: "_static.dif", label: "Resultados", sortable: true },
      { key: "_static.rate", label: "Balance_(%)", sortable: true },
      { key: "staticTimeLast.startUp", label: "Hr_Enc", sortable: true },
      { key: "online", label: "Estado", sortable: true },
      { key: "accion", label: "Action", sortable: false },
    ],
    []
  );

  const onHeaderSort = (key) => {
    const col = columns.find((c) => c.key === key);
    if (!col || !col.sortable) return;

    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const sortArrow = (key) => {
    if (sortBy !== key) return "";
    return sortDir === "asc" ? " ▲" : " ▼";
  };

  // ===================== NORMALIZACIÓN DE FILAS (ONLINE / STATIC TIME) =====================
  const normalizedRows = useMemo(() => {
    return list
      .map((z) => {
        const last = z?.staticTime?.length ? z.staticTime[z.staticTime.length - 1] : null;
        const online = last && (new Date().getTime() - new Date(last.last).getTime()) / 1000 <= 500 ? 1 : 0;

        return {
          ...z,
          staticTimeLast: last ? { ...last } : { startUp: "", last: "" },
          online,
        };
      })
      .sort((a, b) => {
        const ac = safe(a?.customer?._id);
        const bc = safe(b?.customer?._id);
        if (ac > bc) return 1;
        if (ac < bc) return -1;
        const an = safe(a?.name);
        const bn = safe(b?.name);
        return an.localeCompare(bn, undefined, { numeric: true, sensitivity: "base" });
      });
  }, [list]);

  const visibleRows = useMemo(() => {
    const query = q.trim().toLowerCase();
    const filtered = !query ? normalizedRows : normalizedRows.filter((r) => rowToSearchText(r).includes(query));

    if (!sortBy) return filtered;

    const dir = sortDir === "asc" ? 1 : -1;

    const cmp = (a, b) => {
      const va = safe(getByPath(a, sortBy));
      const vb = safe(getByPath(b, sortBy));

      const na = Number(va);
      const nb = Number(vb);
      const bothNum = va !== "" && vb !== "" && !Number.isNaN(na) && !Number.isNaN(nb);

      let res = 0;
      if (bothNum) res = na - nb;
      else res = va.localeCompare(vb, undefined, { numeric: true, sensitivity: "base" });

      return res * dir;
    };

    return filtered.slice().sort(cmp);
  }, [normalizedRows, q, sortBy, sortDir]);

  // ===================== TOTALES =====================
  const totals = useMemo(() => {
    const rows = normalizedRows;
    const sum = (fn) => rows.reduce((acc, r) => acc + (fn(r) || 0), 0);

    return {
      counterTicket: sum((r) => Number(r?._static?.counterTicket) || 0),
      amountBetted: sum((r) => Number(r?._static?.amountBetted) || 0),
      amountWinned: sum((r) => Number(r?._static?.amountWinned) || 0),
      amountPaid: sum((r) => Number(r?._static?.amountPaid) || 0),
      noPaid: sum((r) => Number(r?._static?.noPaid) || 0),
      dep: sum((r) => Number(r?._static?.dep) || 0),
      ret: sum((r) => Number(r?._static?.ret) || 0),
      caja: sum((r) => Number(r?._static?.caja) || 0),
      jackpotPaid: sum((r) => Number(r?._static?.jackpotPaid) || 0),
      dif: sum((r) => Number(r?._static?.dif) || 0),
    };
  }, [normalizedRows]);

  const totalPercent = totals.amountBetted > 0 ? ((totals.dif * 100) / totals.amountBetted).toFixed(2) : "0.00";

  // ===================== HABILITAR / UPDATE / DELETE PUNTO =====================
  const DisaablePoint = useCallback(async (code, state) => {
    try {
      await fetch(`${url}/point`, {
        method: "PUT",
        headers,
        body: JSON.stringify({ code, state: !state }),
      });
    } catch (e) {
      console.error("Error cambiando estado punto:", e);
    }
  }, []);

  const UpdatePoint = (point) => {
    if (localStorage.getItem("level") === "1") {
      // tu lógica
    } else {
      console.log("No tiene privilegios para modificar, favor contactar a un representante");
    }
  };

  const DeletePoint = (point, name) => {
    const options = {
      title: "Eliminar Punto",
      message: `${name}`,
      buttons: [
        {
          label: "Yes",
          className: "btn btn-primary ",
          onClick: async () => {
            try {
              await fetch(`${url}/point/${point}`, {
                headers,
                method: "DELETE",
              });
            } catch (e) {
              console.error("Error eliminando punto:", e);
            }
          },
        },
        { label: "No" },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "card col-4 justify-context-center position-absolute top-0 text-center",
    };

    confirmAlert(options);
  };

  // ===================== ✅ MODAL TICKETS (LISTADO) =====================
  const [showTicketsModal, setShowTicketsModal] = useState(false);
  const [ticketsLoading, setTicketsLoading] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [pointForTickets, setPointForTickets] = useState(null);

  const closeTicketsModal = () => {
    setShowTicketsModal(false);
    setTickets([]);
    setPointForTickets(null);
    // también cerrar modal de detalle si estaba abierto
    setShowTicketDetailModal(false);
    setTicketToView(null);
  };

  const openTicketsModalFromPoint = (pointRow) => {
    setPointForTickets(pointRow);
    setShowTicketsModal(true);

    // tickets precargados (rápido)
    const localTickets = Array.isArray(pointRow?._static?.tickets) ? pointRow._static.tickets : [];
    setTickets([...localTickets]); // ✅ copia
  };

  // ===================== ✅ MODAL DETALLE TICKET (NUEVO) =====================
  const [showTicketDetailModal, setShowTicketDetailModal] = useState(false);
  const [ticketDetailLoading, setTicketDetailLoading] = useState(false);
  const [ticketToView, setTicketToView] = useState(null);

  const closeTicketDetailModal = () => {
    setShowTicketDetailModal(false);
    setTicketToView(null);
  };

  // GET /ticket/:num (trae ticket completo)
  const GetDataTicket = useCallback(async (num) => {
    try {
      setTicketDetailLoading(true);
      setShowTicketDetailModal(true); // ✅ abre modal centrado de una vez

      const res = await fetch(`${url}/ticket/${num}`, { method: "GET", headers });
      const data = await res.json();
console.log("DATA: ",data)
      setTicketToView(data && Array.isArray(data) && data.length > 0 ? data[0] : null);
    } catch (e) {
      console.error("Error cargando detalle ticket:", e);
      setTicketToView(null);
    } finally {
      setTicketDetailLoading(false);
    }
  }, []);

  // pagar ticket
  const payTicket = async (num) => {
    const res = await fetch(`${url}/ticket/pay`, {
      method: "PUT",
      headers,
      body: JSON.stringify({ num }),
    });
    return res.json();
  };

  // eliminar ticket
  const deleteTicket = async (num) => {
    const res = await fetch(`${url}/ticket/${num}`, {
      method: "DELETE",
      headers,
    });
    return res.json();
  };

  const confirmPayTicket = (num) => {
    confirmAlert({
      title: "Pagar Ticket",
      message: `Ticket No. ${num}`,
      buttons: [
        {
          label: "Pagar",
          className: "btn btn-success",
          onClick: async () => {
            try {
              await payTicket(num);

              // ✅ como NO refrescas props, actualiza state local tickets
              setTickets((prev) =>
                prev.map((t) =>
                  t.num === num
                    ? {
                        ...t,
                        winner: { ...(t.winner || {}), paid: true },
                        hourPaid: new Date().toISOString(),
                      }
                    : t
                )
              );

              // si el detalle abierto coincide, también marcarlo
              setTicketToView((prev) =>
                prev && prev.num === num
                  ? { ...prev, winner: { ...(prev.winner || {}), paid: true }, hourPaid: new Date().toISOString() }
                  : prev
              );
            } catch (e) {
              console.error("Error pagando ticket:", e);
            }
          },
        },
        { label: "Cancelar" },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    });
  };

  const confirmDeleteTicket = (num) => {
    confirmAlert({
      title: "Eliminar Ticket",
      message: `Ticket No. ${num}`,
      buttons: [
        {
          label: "Eliminar",
          className: "btn btn-danger",
          onClick: async () => {
            try {
              await deleteTicket(num);

              // ✅ quitar del listado sin depender de props
              setTickets((prev) => prev.filter((t) => t.num !== num));

              // ✅ si estaba abierto en detalle, cerrar
              setTicketToView((prev) => (prev?.num === num ? null : prev));
              if (ticketToView?.num === num) setShowTicketDetailModal(false);
            } catch (e) {
              console.error("Error eliminando ticket:", e);
            }
          },
        },
        { label: "Cancelar" },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    });
  };

  return (
    <div className="table-responsive pt-0 mt-2 card">
      {/* ✅ Filtro */}
      <div className="d-flex gap-2 align-items-center flex-wrap p-2">
        <input className="form-control" style={{ maxWidth: 420 }} placeholder="Filtrar por cualquier campo…" value={q} onChange={(e) => setQ(e.target.value)} />
        <div className="ms-auto small text-muted">
          Mostrando {visibleRows.length} de {normalizedRows.length}
          {sortBy ? ` · Orden: ${sortBy} (${sortDir})` : ""}
        </div>
        {(q || sortBy) && (
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => {
              setQ("");
              setSortBy("");
              setSortDir("asc");
            }}
          >
            Limpiar
          </button>
        )}
      </div>

      <table className="table table-sm table-borded pt-0 mt-0">
        <thead className="text-center">
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                onClick={() => onHeaderSort(c.key)}
                style={{
                  cursor: c.sortable ? "pointer" : "default",
                  userSelect: "none",
                  whiteSpace: "nowrap",
                }}
                title={c.sortable ? "Click para ordenar" : undefined}
              >
                {c.label}
                {c.sortable && sortArrow(c.key)}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {visibleRows && visibleRows.length > 0 ? (
            visibleRows.map((z, idx) => {
              const st = z?._static || {};
              const last = z?.staticTimeLast || null;
              const isOn = z?.online === 1;

              const ticketCount = st.amountBetted != null ? Number(st.counterTicket || 0) : null;

              return (
                <tr key={safe(z.num || z._id || z.code || idx)}>
                  <td>{idx + 1}</td>
                  <td>{safe(z.code)}</td>

                  <td>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" checked={!!z.state} onChange={() => DisaablePoint(z.code, z.state)} />
                      <label className="form-check-label" htmlFor="flexSwitchCheckChecked">
                        {safe(z.name)}
                      </label>
                    </div>
                  </td>

                  <td>{safe(z?.customer?.name || z?.customer)}</td>
                  <td>{safe(z?.address?.city || "")}</td>

                  {/* ✅ CLICK EN EL NÚMERO DE TICKETS -> ABRE MODAL */}
                  <td className="text-center">
                    {ticketCount !== null && ticketCount !== 0 ? (
                      <span style={{ cursor: "pointer", textDecoration: "underline" }} title="Click para ver tickets" onClick={() => openTicketsModalFromPoint(z)}>
                        {safe(ticketCount)}
                      </span>
                    ) : (
                      "0"
                    )}
                  </td>

                  <td className="text-end">{st.amountBetted != null ? n2(st.amountBetted) : ""}</td>
                  <td className="text-end">{st.amountWinned != null ? n2(st.amountWinned) : ""}</td>
                  <td className="text-end">{st.amountPaid != null ? n2(st.amountPaid) : ""}</td>
                  <td className="text-end">{st.noPaid != null ? n2(st.noPaid) : ""}</td>
                  <td className="text-end">{st.dep != null ? n2(st.dep) : ""}</td>
                  <td className="text-end">{st.ret != null ? n2(st.ret) : ""}</td>
                  <td className="text-end">{st.caja != null ? n2(st.caja) : ""}</td>
                  <td className="text-end">{st.jackpotPaid != null ? n2(st.jackpotPaid) : ""}</td>
                  <td className="text-end">{st.dif != null ? n2(st.dif) : ""}</td>

                  <td className="text-end">
                    {st.rate != null ? n2(st.rate) : ""}
                    {st.rate != null ? "%" : ""}
                  </td>

                  <td className="text-end">
                    {z?.staticTime?.length > 0 && new Date(z.staticTime[z.staticTime.length - 1].date).getDate() === new Date().getDate() ? safe(last?.startUp || "") : ""}
                  </td>

                  <td className="text-center">{isOn ? <span className="bg-success btn text-white m-1">ON</span> : <span className="bg-danger btn text-white m-1">OFF</span>}</td>

                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="pr-1 mr-1">
                            <button className="btn btn-primary m-1" onClick={() => handleShow(z)}>
                              <EyeFill />
                            </button>
                          </td>
                          <td>
                            <button className="btn btn-warning m-1" disabled={localStorage.getItem("level") !== "1"} onClick={() => UpdatePoint(z)}>
                              <PenFill />
                            </button>
                          </td>
                          <td>
                            <button className="btn btn-danger m-1" onClick={() => DeletePoint(z._id, z.name)} disabled={localStorage.getItem("level") !== "1"}>
                              <XCircle />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr />
          )}

          {/* ✅ Totales */}
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td>
              <strong>Total</strong>
            </td>

            <td className="text-center">
              <strong>{normalizedRows.length > 0 ? n2(totals.counterTicket) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.amountBetted) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.amountWinned) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.amountPaid) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.noPaid) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.dep) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.ret) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.caja) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.jackpotPaid) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? n2(totals.dif) : "0.00"}</strong>
            </td>

            <td className="text-end">
              <strong>{normalizedRows.length > 0 ? `${totalPercent}%` : "0.00%"}</strong>
            </td>

            <td />
            <td />

            <td>
              <button className="btn btn-warning" onClick={() => ReportPDF(normalizedRows, date)}>
                Imprimir Reporte
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ===================== MODAL: REPORTE DE VENTA (EXISTENTE) ===================== */}
      <Modal show={show} className="p-0 m-0 bg-dark" centered>
        <ModalHeader>
          <h3>Reporte de Venta</h3>
          <button className="btn btn-close" onClick={handleClose}></button>
        </ModalHeader>

        <ModalBody>
          <div className="container m-3 p-3">
            <div className="col-12 row justify-content-between m-0 p-0">
              <div className="col-6 fs-4  border border-dark">Punto</div>
              <div className="col-6 fs-3  border border-dark m-0 p-0 text-center">{pointShow ? safe(pointShow.name) : ""}</div>
            </div>

            <div className="col-12 row justify-content-between border border-dark  m-0 p-0">
              <div className="col-6 fs-4 border border-dark">Fecha: </div>
              <div className="col-6 fs-4 border border-dark text-center">
                {pointShow
                  ? !date || !date.init || date.init === ""
                    ? `${new Date().toLocaleDateString("es-ES")} ${new Date().getHours().toString().padStart(2, "0")}:${new Date()
                        .getMinutes()
                        .toString()
                        .padStart(2, "0")}:${new Date().getSeconds().toString().padStart(2, "0")}`
                    : `${new Date(date.init).toLocaleDateString("es-ES")} - ${new Date(date.end).toLocaleDateString("es-ES")}`
                  : ""}
              </div>
            </div>

            <div className="col-12 row justify-content-between border border-dark  m-0 p-0">
              <div className="col-6 fs-4 border border-dark">Tickets:</div>
              <div className="col-6 fs-4 border border-dark text-center">{pointShow ? n2(pointShow?._static?.counterTicket || 0) : ""}</div>
            </div>

            <div className="col-12 row justify-content-between border border-dark  m-0 p-0">
              <div className="col-6 fs-4 border border-dark">Monto APostado:</div>
              <div className="col-6 fs-4 border border-dark text-center">{pointShow ? n2(pointShow?._static?.amountBetted || 0) : ""}</div>
            </div>

            <div className="col-12 row justify-content-between border border-dark  m-0 p-0">
              <div className="col-6 fs-4 border border-dark">Monto Pagado: </div>
              <div className="col-6 fs-4 border border-dark text-center">{pointShow ? n2(pointShow?._static?.amountPaid || 0) : ""}</div>
            </div>

            <div className="col-12 row justify-content-between border border-dark  m-0 p-0">
              <div className="col-6 fs-4 border border-dark">Jackpots: </div>
              <div className="col-6 fs-4 border border-dark text-center">{pointShow ? n2(pointShow?._static?.jackpotPaid || 0) : ""}</div>
            </div>

            <div className="col-12 row justify-content-between border border-dark  m-0 p-0">
              <div className="col-6 fs-4 border border-dark">Balance: </div>
              <div className="col-6 fs-4 border border-dark text-center">{pointShow ? n2(pointShow?._static?.dif || 0) : ""}</div>
            </div>

            <div className="col-12 row justify-content-between border border-dark  m-0 p-0">
              <div className="col-6 fs-4 border border-dark">Porciento: </div>
              <div className="col-6 fs-4 border border-dark text-center">
                {pointShow && Number(pointShow?._static?.amountBetted) > 0
                  ? `${((Number(pointShow?._static?.dif || 0) * 100) / Number(pointShow?._static?.amountBetted || 1)).toFixed(0)}%`
                  : "0%"}
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter />
      </Modal>

      {/* ===================== ✅ MODAL: TICKETS (LISTADO) ===================== */}
      <Modal show={showTicketsModal} onHide={closeTicketsModal} size="fullscreen" centered className="bg-info">
        <Modal.Header closeButton>
          <Modal.Title>
            Tickets · Punto: {pointForTickets ? safe(pointForTickets.name) : ""}
            {pointForTickets ? ` (${safe(pointForTickets.code)})` : ""}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {ticketsLoading ? (
            <div className="p-3">Cargando tickets…</div>
          ) : tickets && tickets.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered p-0 m-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Num</th>
                    <th>Fecha</th>
                    <th>Hora</th>
                    <th>Evento</th>
                    <th>Apostado</th>
                    <th>Ganador</th>
                    <th>Monto Ganado</th>
                    <th>Factor</th>
                    <th>Jackpot</th>
                    <th>Monto Pagado</th>
                    <th>Estado</th>
                    <th>Hora Pago</th>
                    <th>Accion</th>
                  </tr>
                </thead>

                <tbody>
                  {tickets.map((t, i) => (
                    <tr key={safe(t.num || i)}>
                      <td>{i + 1}</td>
                      <td>{safe(t.num)}</td>
                      <td>{t.date ? new Date(t.date).toLocaleDateString("es-ES") : ""}</td>
                      <td>
                        {t.date
                          ? `${new Date(t.date).getHours().toString().padStart(2, "0")}:${new Date(t.date)
                              .getMinutes()
                              .toString()
                              .padStart(2, "0")}:${new Date(t.date).getSeconds().toString().padStart(2, "0")}`
                          : ""}
                      </td>
                      <td>{safe(t.games && t.games.num? t.games.num: '')}</td>
                      <td className="text-end">{t.amount != null ? n2(t.amount) : ""}</td>
                      <td>{t?.winner?.state ? "Ganador" : ""}</td>
                      <td className="text-end">{t?.winner?.state ? n2(t?.winner?.amountWinner) : ""}</td>
                      <td className="text-end">{safe(t?.winner?.factor)}</td>
                      <td className="text-end">{t?.winner?.jackpot?.value > 0 ? n2(t?.winner?.jackpot?.value) : ""}</td>
                      <td className="text-end">{t?.winner?.state ? n2(t?.winner?.amountToPay) : ""}</td>
                      <td>{t.delete?'Anulado':t.winner.paid ? "Pagado" : t.winner.valided? "Validado":""}</td>
                      <td>
                        {t?.winner?.paid && t?.hourPaid
                          ? `${new Date(t.hourPaid).getHours().toString().padStart(2, "0")}:${new Date(t.hourPaid)
                              .getMinutes()
                              .toString()
                              .padStart(2, "0")}:${new Date(t.hourPaid).getSeconds().toString().padStart(2, "0")}`
                          : ""}
                      </td>

                      <td style={{ whiteSpace: "nowrap" }}>
                        {/* ✅ VER -> abre modal detalle */}
                        <button type="button" className="btn btn-sm btn-primary me-1" onClick={() => GetDataTicket(t.num)} title="Ver ticket">
                          <EyeFill />
                        </button>

                        {/* ✅ PAGAR */}
                        <button type="button" className="btn btn-sm btn-success me-1" onClick={() => confirmPayTicket(t.num)} title="Pagar ticket" disabled={!!t?.winner?.paid}>
                          Pagar
                        </button>

                        {/* ✅ ELIMINAR */}
                        <button type="button" className="btn btn-sm btn-danger" onClick={() => confirmDeleteTicket(t.num)} title="Eliminar ticket">
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="p-3">No hay tickets para este punto.</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" type="button" onClick={closeTicketsModal}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>

      {/* ===================== ✅ MODAL: DETALLE TICKET (CENTRADO) ===================== */}
      <Modal
        show={showTicketDetailModal}
        onHide={closeTicketDetailModal}
        centered
        size="md"
        className="bg-info"
      >
        <Modal.Header closeButton>
          <Modal.Title>Detalle de Ticket</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {ticketDetailLoading ? (
            <div className="p-2">Cargando detalle del ticket…</div>
          ) : ticketToView ? (
            <div className="card p-2">
              <div className="d-flex justify-content-center">
                <img src={imgLogo} alt="logo" style={{ height: 50, objectFit: "contain" }} />
              </div>

              <div className="mt-2">
                <div>
                  <strong>Punto:</strong> {safe(ticketToView?.point?.name)}
                </div>
                <div>
                  <strong>Ticket No.:</strong> {safe(ticketToView?.num)}
                </div>
                <div>
                  <strong>Evento:</strong> {safe(ticketToView?.games?.code || ticketToView?.games.num)}
                </div>
                <div>
                  <strong>Fecha:</strong>{" "}
                  {ticketToView?.date
                    ? `${new Date(ticketToView.date).toLocaleDateString("es-ES")} ${new Date(ticketToView.date)
                        .getHours()
                        .toString()
                        .padStart(2, "0")}:${new Date(ticketToView.date).getMinutes().toString().padStart(2, "0")}:${new Date(ticketToView.date)
                        .getSeconds()
                        .toString()
                        .padStart(2, "0")}`
                    : ""}
                </div>
              </div>

              <table className="table table-sm mt-2">
                <thead>
                  <tr>
                    <th>Codigo</th>
                    <th className="text-end">Opcion</th>
                    <th className="text-end">Line</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(ticketToView?.betted)
                    ? ticketToView.betted.map((b) => (
                        <tr key={safe(b.code)}>
                          <td>{safe(b.code)}</td>
                          <td className="text-end">{b.betted}</td>
                          <td className="text-end">{n2(b.rate)}</td>
                          <td>{b.winner==true?'':<span className="badge bg-danger">X</span>}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              </table>

              <div className="text-end">
                <strong>Total Apostado:</strong> {n2(ticketToView?.amount)}
              </div>
                <div className="text-end">
                <strong>Total A Ganar:</strong> {(ticketToView?.amountToWin.toLocaleString("en-EN", { maximumFractionDigits: 2 }) )}
              </div>
            </div>
          ) : (
            <div className="p-2">No se encontró el ticket.</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" type="button" onClick={closeTicketDetailModal}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default TablePoint;
